import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
const ComponentModal = ({ id = '', closeModal, children, className = '', isWide = false, isNarrowModal = false }) => {
    useEffect(() => {
        if (typeof closeModal !== 'function') {
            return;
        }
        const escPress = ({ key }) => {
            if (key === 'Escape') {
                closeModal();
            }
        };
        window.addEventListener('keydown', escPress);
        return () => {
            window.removeEventListener('keydown', escPress);
        };
    }, []);
    useEffect(() => {
        document.body.setAttribute('scroll', 'no');
        document.body.setAttribute('style', 'overflow:hidden;');
        return () => {
            document.body.removeAttribute('scroll');
            document.body.removeAttribute('style');
        };
    }, []);
    return createPortal(_jsx("div", Object.assign({ id: 'overlay', role: 'button', tabIndex: 0, className: `modal bg-black-modal z-30 w-screen h-screen fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center ${className}`, onClick: handleClickOverlay }, { children: _jsxs("div", Object.assign({ id: id, className: `modal-content overflow-y-auto relative bg-dark-teal w-full h-screen z-30 p-8 pb-24 md:py-10 md:px-12 md:h-auto ${isWide ? 'md:w-3/4' : 'md:w-3/5'} ${isNarrowModal ? 'lg:w-510' : 'lg:w-715'} flex flex-col` }, { children: [typeof closeModal === 'function' && (_jsxs("div", Object.assign({ role: 'button', tabIndex: 0, className: 'close-modal w-6 h-6 absolute top-0 right-0 mt-4 mr-2 lg:mt-5 lg:mr-2 cursor-pointer z-40', onClick: closeModal }, { children: [_jsx("span", { className: 'w-full h-1 bg-gray-700 block transform rotate-45 absolute right-0' }), _jsx("span", { className: 'w-full h-1 bg-gray-700 block transform -rotate-45' })] }))), children] })) })), document.body);
    function handleClickOverlay({ target }) {
        if (target.id === 'overlay' && typeof closeModal === 'function') {
            closeModal();
        }
    }
};
ComponentModal.propTypes = {
    id: PropTypes.string,
    closeModal: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    isWide: PropTypes.bool,
    isNarrowModal: PropTypes.bool
};
export default ComponentModal;
